import React from "react";

const SVG = ({
  style = {},
  fill = "#000",
  className = "",
  width="17.469",
  height="17.469", 
  viewBox="0 0 17.469 17.469"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path fill={fill} id="date" d="M99.83 87.478a8.734 8.734 0 1 0 2.558 6.176 8.677 8.677 0 0 0-2.558-6.176zm-6.171-.54a.814.814 0 1 1-.815.814.814.814 0 0 1 .816-.814zm-5.9 7.532a.82.82 0 1 1 .821-.82.82.82 0 0 1-.822.82zm5.9 5.9h-.066a.818.818 0 1 1 .068 0zm4.586-9.87l-4.381 5.22a.374.374 0 0 1-.55.025L89.943 92.4a.507.507 0 0 1-.02-.7l.566-.629a.507.507 0 0 1 .7-.053l2.226 1.819 3.459-3.581a.507.507 0 0 1 .7-.025l.619.557a.507.507 0 0 1 .052.712zm1.308 3.979a.816.816 0 1 1 .817-.815.816.816 0 0 1-.816.811z" className="cls-1" transform="translate(-84.92 -84.92)"/>
  </svg>
);

export default SVG;



// WEBPACK FOOTER //
// ./src/components/UI/Icons/Data.js